import { oneLineTrim } from 'common-tags';

// What is this?
export function isNumericKey(e, withDecimal) {
  const key = e.charCode || e.keyCode || 0;

  return (
    key == 8 ||
    key == 9 ||
    key == 46 ||
    (key >= 37 && key <= 40) ||
    (key >= 48 && key <= 57) ||
    (key >= 96 && key <= 105) ||
    (withDecimal && (key == 110 || key == 190)));
}

/* AUTO INCREASE LANDING PAGE COUNTER */
export function addCommas(nStr) {
  nStr += '';
  const x = nStr.split('.');
  let x1 = x[0];
  const x2 = x.length > 1 ? `.${x[1]}` : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1,$2');
  }
  return x1 + x2;
}

export function isValidEmail(email) {
  // TODO: Check unit test as the regex has failed to catch no TLD domains.
  const re = new RegExp(
    oneLineTrim`^(([^<>()\\[\\]\\\.,;:\\s@"]+(\\.[^<>()\\[\\]
    \\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]
    {1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$`,
  );
  return re.test(email);
}

export function isValidUsernameFormat(username) {
  const re = /^[a-z][a-z0-9]{2,15}$/i;
  return re.test(username);
}

export function isValidPasswordFormat(password) {
  const len = password.length;
  const nums = password.match(/\d/g);
  const lowers = password.match(/[a-z]/g);
  const uppers = password.match(/[A-Z]/g);
  const pattern = /^.{6,}$/i;

  if (pattern.test(password)) {
    let strengthLevel = 0;
    if (nums) {
      strengthLevel += 2;
    }
    if (lowers) {
      strengthLevel += uppers ? 4 : 3;
    }
    if (uppers) {
      strengthLevel += lowers ? 4 : 3;
    }
    if (len > 10) {
      strengthLevel += 1;
    }

    if (strengthLevel <= 4) {
      return false;
    } else if (strengthLevel > 4 && strengthLevel <= 8) {
      return true;
    }

    return true;
  }
  return false;
}
